/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Reason_Rate_LimitedInputs */

const en_sorx_reason_rate_limited = /** @type {(inputs: Sorx_Reason_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`too many messages in a short time`)
};

const id_sorx_reason_rate_limited = /** @type {(inputs: Sorx_Reason_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terlalu banyak pesan dalam waktu singkat`)
};

/**
* | output |
* | --- |
* | "too many messages in a short time" |
*
* @param {Sorx_Reason_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_reason_rate_limited = /** @type {((inputs?: Sorx_Reason_Rate_LimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Reason_Rate_LimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_reason_rate_limited(inputs)
	return en_sorx_reason_rate_limited(inputs)
});